<template>  
  <v-component>
      <v-layout align-center justify-center>
        <BackendMessageList 
          :editionMode="editionMode" 
          :messages="campaign.welcomeMessages" 
          jsonpath="$.welcomeMessages"
          @change="messageChanged"
        ></BackendMessageList>
      </v-layout>
  </v-component>
</template>

<script>
import BackendMessageList from "./BackendMessageList.vue"
export default {
  props: ["message", "editionMode", "campaign"],
  components: {
    BackendMessageList
  },
  methods: {
    messageChanged(event) {
      this.$emit("change", event)
    },
  }
}
</script>